import styled, {css} from "styled-components"
import Card from "@irati/ui/src/experimental/Card"

interface PlayOverlayProps {
  isPlaying: boolean
}

interface VideoProps {
  thumbnail: string
}

export const PlayOverlayWrapper = styled.div<PlayOverlayProps>`
  ${({isPlaying}) => css`
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 60px;
    right: 0;
    left: 0;
    opacity: 1;
    transition: opacity 0.2s, height 4s;

    img {
      position: absolute;
      width: 70px;
      height: 70px;
      margin: -35px 0 0 -35px;
      top: 50%;
      left: 50%;
    }

    ${isPlaying &&
    `
    opacity: 0;
  `}
  `}
`

export const OverlayBg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.6;
`

export const PlayerWrapper = styled(Card)<VideoProps>`
  ${({thumbnail}) => css`
    position: relative;
    background-image: url("${thumbnail}");
    background-size: cover;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
  `}
`
